<template lang="pug">
  #section4.section
    #s4s1
      #s4s1a1.group
        #s4s1a1b1
          .fake-header
          .block  
            .slide
              p.bold.smaller(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
              ) Este es un relato que es posible gracias a la participación de las víctimas directas e indirectas de&nbsp;
                span.green El Quemado. 
          .fake-footer
        #s4s1a1b2
          .fake-header
          .block  
            .slide
              p.bold(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
              )  Su lucha por recibir una reparación integral y digna conforme a sus derechos exigió que su historia fuera contada más allá de un monumento y se se construyera con un  
                 span.green Memorial Integral 
                 span compuesto por espacios públicos, con la finalidad de acercar su acceso a la educación y la cultura, así como el apoyo de herramientas digitales, investigación documental y el registro audiovisual del proceso de dicho Memorial.
          .fake-footer
        #s4s1a1b3
          .fake-header
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Section3/3.7.2 Reparación Integral_2.jpg")
              p.bold(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
              )  Este ejercicio es el que finalmente permite que El Quemado&nbsp;
                span.accent-text acceda a la reparación integral por la violencia que sufrieron hace más de 47 años.
          .fake-footer
      #s4s1a2.group
        // text group        
        #s4s1a2b1
          .block  
            .text-slide
              p.smaller.bold.text-right El objetivo de este proyecto es no solo recordar el pasado, sino&nbsp; 
                span.green crear espacios y herramientas públicas&nbsp;
                | que nos permitan reducir el riesgo a que estas violencias vuelvan a ocurrir.
        #s4s1a2b2
          .block  
            .text-slide
              p.bold.small También parte de su reparación integral es el fortalecimiento de sus productividad agrícola para obtener autosuficiencia económica. Te invitamos a que acerques a la comunidad de El Quemado en la sección de Contacto y que también continúes explorando el Memorial Integral:
        #s4s1a2b3
          .block
            .row.button-list
              .col-12
                b-button.mx-3(variant="outline-light" href="https://mapa-mvdf.datacivica.org/" target="_blank") MEMORIAL DISPERSO
                b-button.mx-3(variant="outline-light" href="http://mvdf.datacivica.org/testimonios" target="_blank") TESTIMONIOS
                b-button.mx-3(variant="outline-light" href="http://mvdf.datacivica.org/" target="_blank") DOCUMENTAL
    
</template>
<script>
export default {
  name: "Section4"
}
</script>
<style lang="scss" scoped>
#section4 {
  background-color: #000;
}

#s4s1a1 {
  min-height: 600vh;
  #s4s1a1b1 {
    .fake-header {
      @include fakinH(4vh, 0%);
    }
    .fake-footer {
      @include fakinF(1.6vh, 55%);
    }
    .block {
      @include blockin(100%, 35%, 5%, 0%);
      p {
        @include blockinP(42%, 15%, 55%);
      }
    }
  }
  #s4s1a1b2 {
    .fake-header {
      @include fakinH(1.6vh, 5%);
    }
    .fake-footer {
      @include fakinF(1.6vh, 50%);
    }
    .block {
      @include blockin(100%, 40%, 13%, 0%);
      p {
        @include blockinP(80%, 40%, 10%);
      }
    }
  }
  #s4s1a1b3 {
    .fake-header {
      @include fakinH(1.6vh, 53%);
    }
    .fake-footer {
      @include fakinF(1.6vh, 5%);
    }
    .block {
      @include blockin(100%, 40%, 55%, 0%);
      img {
        @include blockinImg(80%, 57vh, 18%);
        margin-bottom: 16%;
      }
      p {
        @include blockinP(80%, 73%, 10%);
      }
    }
  }
}
#s4s1a2 {
  height: 100vh;
  #s4s1a2b1 {
    .block {
      @include blockin(100%, 100%, 0%, 0%);
      p {
        @include blockinP(60%, 12%, 35%);
      }
    }
  }
  #s4s1a2b2 {
    .block {
      @include blockin(100%, 73%, 27%, 0%);
      p {
        @include blockinP(80%, 30%, 10%);
      }
    }
  }
  #s4s1a2b3 {
    .block {
      @include blockin(100%, 100%, 0%, 0%);
      .button-list {
        @include blockinP(50%, 65%, 25%);
        position: absolute;
        .btn { 
          border-width: 1.5px;
          font-weight: 600;
          width: 100%;
          max-width: 190px;
          margin-top: 1rem;
          padding: 8px;
          border-radius: 10px;
          line-height: 1.1; 
        }
      }
    }
  }
}
</style>